"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserStatusIcon = UserStatusIcon;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("../constants");
var _styled = require("../styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var AVAILABLE = _constants.userStatusType.AVAILABLE,
  AWAY = _constants.userStatusType.AWAY,
  BUSY = _constants.userStatusType.BUSY,
  DO_NOT_DISTURB = _constants.userStatusType.DO_NOT_DISTURB,
  OFFLINE = _constants.userStatusType.OFFLINE,
  ON_BREAK = _constants.userStatusType.ON_BREAK,
  ON_CALL = _constants.userStatusType.ON_CALL,
  WORKING_OFFLINE = _constants.userStatusType.WORKING_OFFLINE,
  ON_DIRECT_CALL = _constants.userStatusType.ON_DIRECT_CALL;
var getIcon = function getIcon(status) {
  switch (status) {
    case AVAILABLE:
      return _styled.UserStatusIconAvailable;
    case ON_DIRECT_CALL:
      return _styled.UserStatusIconOnDirectCall;
    case AWAY:
      return _styled.UserStatusIconAway;
    case BUSY:
      return _styled.UserStatusIconBusy;
    case DO_NOT_DISTURB:
      return _styled.UserStatusIconDoNotDisturb;
    case OFFLINE:
      return _styled.UserStatusIconOffline;
    case ON_BREAK:
      return _styled.UserStatusIconOnBreak;
    case ON_CALL:
      return _styled.UserStatusIconOnCall;
    case WORKING_OFFLINE:
      return _styled.UserStatusIconWorkingOffline;
    default:
      return null;
  }
};
function UserStatusIcon(_ref) {
  var status = _ref.status;
  var UserStatusSvg = getIcon(status);
  return UserStatusSvg ? /*#__PURE__*/_react["default"].createElement(UserStatusSvg, {
    "aria-hidden": "true"
  }) : null;
}
UserStatusIcon.propTypes = {
  /**
   * Define status version of UserStatus
   */
  status: _propTypes["default"].oneOf(Object.values(_constants.userStatusType)).isRequired
};
var _default = UserStatusIcon;
exports["default"] = _default;